/** A span of a recording, in seconds from the start of the audio. */
export interface TimeRange {
  startSeconds: number;
  durationSeconds: number;
}

/** Formats an offset into a recording as `m:ss`, or `h:mm:ss` once past an hour. */
export const formatRecordingOffset = (seconds: number): string => {
  const whole = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(whole / 3600);
  const minutes = Math.floor((whole % 3600) / 60);
  const secs = whole % 60;

  const padded = `${minutes.toString().padStart(hours > 0 ? 2 : 1, '0')}:${secs
    .toString()
    .padStart(2, '0')}`;

  return hours > 0 ? `${hours}:${padded}` : padded;
};

export const formatRecordingTimestamp = (seconds: number): string => {
  const whole = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const pad = (value: number) => value.toString().padStart(2, '0');
  return `${pad(Math.floor(whole / 3600))}:${pad(Math.floor((whole % 3600) / 60))}:${pad(whole % 60)}`;
};
